module.exports = __webpack_public_path__ + "img/0ecf641.jpg";